var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysPrint = function SvgSysPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.61 14A.612.612 0 0 1 4 13.387V12h-.4A1.528 1.528 0 0 1 2 10.559v-4.12a1.53 1.53 0 0 1 1.6-1.441H4V2.865a.861.861 0 0 1 .536-.803.867.867 0 0 1 .333-.066h6.267a.869.869 0 0 1 .864.87V5h.407a1.528 1.528 0 0 1 1.6 1.441v4.12a1.53 1.53 0 0 1-1.6 1.441H12v1.385a.6.6 0 0 1-.176.431.61.61 0 0 1-.43.18L4.61 14Zm.388-1h6v-1h-6v1Zm-2-6.559v4.12c0 .24.271.441.6.441h8.808c.32 0 .593-.2.593-.441V6.44c0-.24-.271-.441-.593-.441H12v1.135a.867.867 0 0 1-.864.863H4.87A.866.866 0 0 1 4 7.135V6h-.4c-.33 0-.6.2-.6.441h-.002Zm2 .559h6V3h-6v4Zm5.5 3a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1Z"
  })));
};
export default SvgSysPrint;